import React from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, MenuProps } from '../../../components/MenuItem';
import utex from './static/img/utex.svg';

export const Menu: React.FC<MenuProps> = (props) => {
  const { t } = useTranslation('byUtex');

  return (
    <MenuItem
      {...props}
      fee={undefined} // force description to be shown
      icon={utex}
      name={t('From UTEX account')}
      description={t('No registration needed')}
    />
  );
};
